export default __webpack_public_path__ + "static/media/formation1.40c03935.png";